// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react:true*/
import React, {useContext} from 'react';
import {Settings_context} from '../settings_ctx';
import {use_translation_v} from '../lib/trans_v';
import styles from './paragraph.module.less';
import cn from 'classnames';
import {Editor} from '../../../shared/editor/editor';

interface i_paragraph {
    title: string;
    text: string;
    image?: string;
    image_left?: boolean;
}

interface i_paragraph_editor_props {
    value: i_paragraph;
    on_change: (new_value: i_paragraph)=>void;
}

export const Paragraph = (props: i_paragraph)=>{
    const {theme} = useContext(Settings_context);
    const {T} = use_translation_v({no_defaults: true});
    return <div className={cn(styles.wrapper,
      props.image && !props.image_left && styles.wrapper_reverse)}>
      {props.image &&
        <div className={styles.image}
          style={{backgroundImage: `url(${props.image})`}}/>}
      <div className={styles.p_wrapper}>
        <p className={cn(theme.H3, theme.color_n700, styles.title)}>
          <T>{props.title}</T></p>
        <p className={cn(theme.p2, theme.reg, theme.color_n600)}>
          <T>{props.text}</T></p>
      </div>
    </div>;
};

export const Paragraph_editor = (props: i_paragraph_editor_props)=>{
  const {value = {title: '', text: '', image: '',
    image_left: false}, on_change} = props;
  type editor_key = keyof i_paragraph;
  type editor_type = 'text' | 'textarea' | 'number' | 'boolean' | 'selector';
  const editors = [
      ['title', 'Title', 'text'],
      ['text', 'Text', 'text'],
      ['image', 'Image', 'text'],
      ['image_left', 'Image position: on=left', 'boolean'],
  ].map(([key, label, type])=>({key: key as editor_key, label,
      type: type as editor_type}));
  return <Editor
    value={value}
    editors={editors}
    on_change={on_change}
    title="Paragraph"
  />;
};
